import { useCallback, useState } from 'react'
import * as Api from 'apps/fleet-planner/utils/api'

/**
 * Manages the state for QuickBooks API integration endpoints
 */
export const useQuickBooksApi = () => {
  const [isLoading, setLoading] = useState(false)
  const [error, setError] = useState<string | undefined>()

  /**
   * Callback method used when finishing the auth
   * integration flow from another window
   */
  const exchangeAuthCodeStore = useCallback(
    async (request: Api.IQuickBooksAuthStoreRequest): Promise<boolean> => {
      setLoading(true)
      try {
        await Api.exchangeAuthCodeStore(request)
        setError(undefined)
        setLoading(false)
        return true
      } catch (e) {
        setLoading(false)
        setError(e)
        return false
      }
    },
    []
  )

  /**
   * Generates URL that the user will navigate
   * to when beginning the integration flow
   */
  const getQuickBooksGrantUrl = useCallback(async (): Promise<string> => {
    setLoading(true)
    try {
      const res = await Api.getQuickBooksGrantUrl()
      setError(undefined)
      setLoading(false)
      return res.grantUrl
    } catch (e) {
      setLoading(false)
      setError(e)
      return ''
    }
  }, [])

  /**
   * Creates a new invoice from Load Details page
   */
  const createQuickbooksInvoice = useCallback(async (shipmentId: string): Promise<any> => {
    setLoading(true)
    try {
      const res = await Api.createQuickbooksInvoice(shipmentId)
      setError(undefined)
      setLoading(false)
      return res
    } catch (e) {
      setLoading(false)
      setError(e)
      return undefined
    }
  }, [])

  return {
    isLoading,
    error,
    exchangeAuthCodeStore,
    getQuickBooksGrantUrl,
    createQuickbooksInvoice,
  }
}
